import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    editModeLayout: {
      display: 'grid',
      flexDirection: 'column',
      gap: theme.spacing(2),
      margin: theme.spacing(1, 0),
    },
  };
};
